// extracted by mini-css-extract-plugin
module.exports = {"root":"breadcrumb-item_root__7rHqv","arrowIcon":"breadcrumb-item_arrowIcon__4U06i"};